import { colorConstants } from 'config/colorConstants';
import { LenseConfig } from 'types/pricingSimulator';

export const pvmVarianceData = {
    parsedChartData: [
        {
            data: [
                {
                    sales: -16827089,
                    labelSales: -16827089,
                    category: 'Prior Year',
                    color: 'blue',
                    disableHover: true,
                },
                {
                    sales: 9353830,
                    labelSales: 9353830,
                    category: 'Price Impact',
                    color: '#42A531',
                    disableHover: false,
                },
                {
                    sales: -23381514,
                    labelSales: -23381514,
                    category: 'Vol Impact',
                    color: '#CA3D3D',
                    disableHover: false,
                },
                {
                    sales: -27248420,
                    labelSales: -27248420,
                    category: 'Mix Impact',
                    color: '#CA3D3D',
                    disableHover: false,
                },
                {
                    sales: 24073797,
                    labelSales: 24073797,
                    category: 'Others',
                    color: '#42A531',
                    disableHover: false,
                },
                {
                    sales: 28073797,
                    labelSales: 28073797,
                    category: 'Actual Year',
                    color: 'blue',
                    disableHover: true,
                },
            ],
            minVal: -27248420,
            maxVal: 24073797,
        },
        {
            data: [
                {
                    sales: -16827089,
                    labelSales: -16827089,
                    category: 'TOTAL',
                    color: '#CA3D3D',
                    disableHover: true,
                },
                {
                    sales: 9353830,
                    labelSales: 9353830,
                    category: 'GENERAL MILLS',
                    color: '#42A531',
                    disableHover: false,
                },
                {
                    sales: -23381514,
                    labelSales: -23381514,
                    category: 'PRIVATE LABEL',
                    color: '#CA3D3D',
                    disableHover: false,
                },
                {
                    sales: -27248420,
                    labelSales: -27248420,
                    category: 'KELLOGGS',
                    color: '#CA3D3D',
                    disableHover: false,
                },
                {
                    sales: 24073797,
                    labelSales: 24073797,
                    category: 'PEPSICO',
                    color: '#42A531',
                    disableHover: false,
                },
            ],
            minVal: -27248420,
            maxVal: 24073797,
        },
    ],
    parsedTableData: [
        {
            type: 'Volume Sales CP',
            'TOTAL ': [
                {
                    data: 1202833465,
                    unit: '',
                },
            ],
            'GENERAL MILLS ': [
                {
                    data: 297343043,
                    unit: '',
                },
            ],
            'PRIVATE LABEL ': [
                {
                    data: 181597102,
                    unit: '',
                },
            ],
            'KELLOGGS ': [
                {
                    data: 162371981,
                    unit: '',
                },
            ],
            'PEPSICO ': [
                {
                    data: 152095271,
                    unit: '',
                },
            ],
            'CLIF ': [
                {
                    data: 105397067,
                    unit: '',
                },
            ],
            'KIND ': [
                {
                    data: 69108142,
                    unit: '',
                },
            ],
            'MCKEE FOODS CORPORATION ': [
                {
                    data: 50204143,
                    unit: '',
                },
            ],
            'MONDELEZ INTERNATIONAL INC ': [
                {
                    data: 33271820,
                    unit: '',
                },
            ],
            'ABBOTT LABORATORIES INC ': [
                {
                    data: 18783602,
                    unit: '',
                },
            ],
            'GLANBIA PLC ': [
                {
                    data: 16344547,
                    unit: '',
                },
            ],
            'THE SIMPLY GOOD FOODS COMPANY ': [
                {
                    data: 15430751,
                    unit: '',
                },
            ],
            'BELLA FOUR BAKERY/SONDA FOODS ': [
                {
                    data: 14055298,
                    unit: '',
                },
            ],
            'ATKINS ': [
                {
                    data: 13227929,
                    unit: '',
                },
            ],
            'WORLDWIDE SPORTS NUTRITION ': [
                {
                    data: 11975615,
                    unit: '',
                },
            ],
            'BIONUTRITIONAL RESEARCH GROUP ': [
                {
                    data: 9374990,
                    unit: '',
                },
            ],
            'THE HAIN CELESTIAL GROUP INC ': [
                {
                    data: 6290100,
                    unit: '',
                },
            ],
            'RIVERSIDE NATURAL FOODS LTD ': [
                {
                    data: 5051088,
                    unit: '',
                },
            ],
            'SIMPLY DELICIOUS INC ': [
                {
                    data: 5022198,
                    unit: '',
                },
            ],
            'GOMACRO LLC ': [
                {
                    data: 3694553,
                    unit: '',
                },
            ],
            'PERVINE FOODS LLC ': [
                {
                    data: 2968607,
                    unit: '',
                },
            ],
            'THATS IT NUTRITION LLC ': [
                {
                    data: 2328043,
                    unit: '',
                },
            ],
            'BAKER MILLS ': [
                {
                    data: 2207930,
                    unit: '',
                },
            ],
            'ALANI NUTRITION LLC ': [
                {
                    data: 2045429,
                    unit: '',
                },
            ],
            'DS NATURALS LLC ': [
                {
                    data: 1509291,
                    unit: '',
                },
            ],
            "LENNY AND LARRY'S ": [
                {
                    data: 1424174,
                    unit: '',
                },
            ],
            'FLOWERS FOODS LLC ': [
                {
                    data: 1368290,
                    unit: '',
                },
            ],
            'MET-RX NUTRITION INC ': [
                {
                    data: 1334792,
                    unit: '',
                },
            ],
            'PROMAX ': [
                {
                    data: 1274431,
                    unit: '',
                },
            ],
            'POST HOLDINGS INC ': [
                {
                    data: 1246083,
                    unit: '',
                },
            ],
            'CAMPBELL SOUP CO ': [
                {
                    data: 1245892,
                    unit: '',
                },
            ],
            'LIFESTYLE EVOLUTION ': [
                {
                    data: 1164501,
                    unit: '',
                },
            ],
            'WW INTERNATIONAL INC ': [
                {
                    data: 1146246,
                    unit: '',
                },
            ],
            'THE HERSHEY COMPANY ': [
                {
                    data: 1007434,
                    unit: '',
                },
            ],
            'UNILEVER ': [
                {
                    data: 829226,
                    unit: '',
                },
            ],
            'TINO KAI LLC ': [
                {
                    data: 804109,
                    unit: '',
                },
            ],
            'JUNKLESS FOODS ': [
                {
                    data: 718470,
                    unit: '',
                },
            ],
            "BOB'S RED MILL NTRL FOODS ": [
                {
                    data: 651559,
                    unit: '',
                },
            ],
            'NUTRITION BAR CONFECTIONERS ': [
                {
                    data: 543575,
                    unit: '',
                },
            ],
            'GRAB THE GOLD INC ': [
                {
                    data: 530967,
                    unit: '',
                },
            ],
            'CORE FOODS ': [
                {
                    data: 454512,
                    unit: '',
                },
            ],
            'ARTISAN CONFECTIONS COMPANY ': [
                {
                    data: 398509,
                    unit: '',
                },
            ],
            'MUNK PACK ': [
                {
                    data: 366530,
                    unit: '',
                },
            ],
            'SOUTH 40 SNACKS LLC ': [
                {
                    data: 361951,
                    unit: '',
                },
            ],
            'ALOHA ': [
                {
                    data: 336358,
                    unit: '',
                },
            ],
            'PAMELAS PRODUCTS INC ': [
                {
                    data: 334822,
                    unit: '',
                },
            ],
            'IQ BAR ': [
                {
                    data: 328021,
                    unit: '',
                },
            ],
            'UNDERCOVER CHOCOLATE CO LLC ': [
                {
                    data: 305638,
                    unit: '',
                },
            ],
            'SIMPLE MILLS ': [
                {
                    data: 249145,
                    unit: '',
                },
            ],
            'VERB ENERGY INC ': [
                {
                    data: 204100,
                    unit: '',
                },
            ],
            'BUILT BRANDS LLC ': [
                {
                    data: 190054,
                    unit: '',
                },
            ],
            'GOOD MEASURE ': [
                {
                    data: 179284,
                    unit: '',
                },
            ],
            'ENER G FOODS ': [
                {
                    data: 157982,
                    unit: '',
                },
            ],
            'THIS BAR SAVES LIVES LLC ': [
                {
                    data: 152861,
                    unit: '',
                },
            ],
            'KRISP NUTRITION ': [
                {
                    data: 149915,
                    unit: '',
                },
            ],
            'BLAKES SEED BASED LLC ': [
                {
                    data: 135122,
                    unit: '',
                },
            ],
            '1ST PHORM ': [
                {
                    data: 129396,
                    unit: '',
                },
            ],
            'VITAL PROTEINS LLC ': [
                {
                    data: 129362,
                    unit: '',
                },
            ],
            'TRAM BAR LLC ': [
                {
                    data: 127868,
                    unit: '',
                },
            ],
            'KISS MY KETO LLC ': [
                {
                    data: 117780,
                    unit: '',
                },
            ],
            'WEST THOMAS PARTNERS LLC ': [
                {
                    data: 102436,
                    unit: '',
                },
            ],
        },
        {
            type: 'Volume Sales YA',
            'TOTAL ': [
                {
                    data: 1219660554,
                    unit: '',
                },
            ],
            'GENERAL MILLS ': [
                {
                    data: 287989213,
                    unit: '',
                },
            ],
            'PRIVATE LABEL ': [
                {
                    data: 204978616,
                    unit: '',
                },
            ],
            'KELLOGGS ': [
                {
                    data: 189620401,
                    unit: '',
                },
            ],
            'PEPSICO ': [
                {
                    data: 128021474,
                    unit: '',
                },
            ],
            'CLIF ': [
                {
                    data: 120102769,
                    unit: '',
                },
            ],
            'KIND ': [
                {
                    data: 76674582,
                    unit: '',
                },
            ],
            'MCKEE FOODS CORPORATION ': [
                {
                    data: 51943660,
                    unit: '',
                },
            ],
            'MONDELEZ INTERNATIONAL INC ': [
                {
                    data: 19970560,
                    unit: '',
                },
            ],
            'ABBOTT LABORATORIES INC ': [
                {
                    data: 20559814,
                    unit: '',
                },
            ],
            'GLANBIA PLC ': [
                {
                    data: 17764868,
                    unit: '',
                },
            ],
            'THE SIMPLY GOOD FOODS COMPANY ': [
                {
                    data: 12481244,
                    unit: '',
                },
            ],
            'BELLA FOUR BAKERY/SONDA FOODS ': [
                {
                    data: 15610302,
                    unit: '',
                },
            ],
            'ATKINS ': [
                {
                    data: 14374981,
                    unit: '',
                },
            ],
            'WORLDWIDE SPORTS NUTRITION ': [
                {
                    data: 9823578,
                    unit: '',
                },
            ],
            'BIONUTRITIONAL RESEARCH GROUP ': [
                {
                    data: 10446361,
                    unit: '',
                },
            ],
            'THE HAIN CELESTIAL GROUP INC ': [
                {
                    data: 3498064,
                    unit: '',
                },
            ],
            'RIVERSIDE NATURAL FOODS LTD ': [
                {
                    data: 4785563,
                    unit: '',
                },
            ],
            'SIMPLY DELICIOUS INC ': [
                {
                    data: 4686184,
                    unit: '',
                },
            ],
            'GOMACRO LLC ': [
                {
                    data: 2935483,
                    unit: '',
                },
            ],
            'PERVINE FOODS LLC ': [
                {
                    data: 2112761,
                    unit: '',
                },
            ],
            'THATS IT NUTRITION LLC ': [
                {
                    data: 2101625,
                    unit: '',
                },
            ],
            'BAKER MILLS ': [
                {
                    data: 1437049,
                    unit: '',
                },
            ],
            'ALANI NUTRITION LLC ': [
                {
                    data: 222871,
                    unit: '',
                },
            ],
            'DS NATURALS LLC ': [
                {
                    data: 1658003,
                    unit: '',
                },
            ],
            "LENNY AND LARRY'S ": [
                {
                    data: 463662,
                    unit: '',
                },
            ],
            'FLOWERS FOODS LLC ': [
                {
                    data: 2920,
                    unit: '',
                },
            ],
            'MET-RX NUTRITION INC ': [
                {
                    data: 970712,
                    unit: '',
                },
            ],
            'PROMAX ': [
                {
                    data: 801608,
                    unit: '',
                },
            ],
            'POST HOLDINGS INC ': [
                {
                    data: 226923,
                    unit: '',
                },
            ],
            'CAMPBELL SOUP CO ': [
                {
                    data: 336840,
                    unit: '',
                },
            ],
            'LIFESTYLE EVOLUTION ': [
                {
                    data: 1096691,
                    unit: '',
                },
            ],
            'WW INTERNATIONAL INC ': [
                {
                    data: 4430,
                    unit: '',
                },
            ],
            'THE HERSHEY COMPANY ': [
                {
                    data: 1588017,
                    unit: '',
                },
            ],
            'UNILEVER ': [
                {
                    data: 4043700,
                    unit: '',
                },
            ],
            'TINO KAI LLC ': [
                {
                    data: 276585,
                    unit: '',
                },
            ],
            'JUNKLESS FOODS ': [
                {
                    data: 354,
                    unit: '',
                },
            ],
            "BOB'S RED MILL NTRL FOODS ": [
                {
                    data: 153516,
                    unit: '',
                },
            ],
            'NUTRITION BAR CONFECTIONERS ': [
                {
                    data: 788477,
                    unit: '',
                },
            ],
            'GRAB THE GOLD INC ': [
                {
                    data: 573577,
                    unit: '',
                },
            ],
            'CORE FOODS ': [
                {
                    data: 441151,
                    unit: '',
                },
            ],
            'ARTISAN CONFECTIONS COMPANY ': [
                {
                    data: 103974,
                    unit: '',
                },
            ],
            'MUNK PACK ': [
                {
                    data: 462288,
                    unit: '',
                },
            ],
            'SOUTH 40 SNACKS LLC ': [
                {
                    data: null,
                    unit: '',
                },
            ],
            'ALOHA ': [
                {
                    data: 1973,
                    unit: '',
                },
            ],
            'PAMELAS PRODUCTS INC ': [
                {
                    data: 1400,
                    unit: '',
                },
            ],
            'IQ BAR ': [
                {
                    data: 148963,
                    unit: '',
                },
            ],
            'UNDERCOVER CHOCOLATE CO LLC ': [
                {
                    data: 495699,
                    unit: '',
                },
            ],
            'SIMPLE MILLS ': [
                {
                    data: 258045,
                    unit: '',
                },
            ],
            'VERB ENERGY INC ': [
                {
                    data: null,
                    unit: '',
                },
            ],
            'BUILT BRANDS LLC ': [
                {
                    data: 639,
                    unit: '',
                },
            ],
            'GOOD MEASURE ': [
                {
                    data: 10564,
                    unit: '',
                },
            ],
            'ENER G FOODS ': [
                {
                    data: 162635,
                    unit: '',
                },
            ],
            'THIS BAR SAVES LIVES LLC ': [
                {
                    data: null,
                    unit: '',
                },
            ],
            'KRISP NUTRITION ': [
                {
                    data: 456,
                    unit: '',
                },
            ],
            'BLAKES SEED BASED LLC ': [
                {
                    data: 110046,
                    unit: '',
                },
            ],
            '1ST PHORM ': [
                {
                    data: null,
                    unit: '',
                },
            ],
            'VITAL PROTEINS LLC ': [
                {
                    data: 25435,
                    unit: '',
                },
            ],
            'TRAM BAR LLC ': [
                {
                    data: 36364,
                    unit: '',
                },
            ],
            'KISS MY KETO LLC ': [
                {
                    data: 158539,
                    unit: '',
                },
            ],
            'WEST THOMAS PARTNERS LLC ': [
                {
                    data: 371028,
                    unit: '',
                },
            ],
        },
        {
            type: 'Volume Sales Abs Change',
            'TOTAL ': [
                {
                    data: -16827089,
                    unit: '',
                },
            ],
            'GENERAL MILLS ': [
                {
                    data: 9353830,
                    unit: '',
                },
            ],
            'PRIVATE LABEL ': [
                {
                    data: -23381514,
                    unit: '',
                },
            ],
            'KELLOGGS ': [
                {
                    data: -27248420,
                    unit: '',
                },
            ],
            'PEPSICO ': [
                {
                    data: 24073797,
                    unit: '',
                },
            ],
            'CLIF ': [
                {
                    data: -14705702,
                    unit: '',
                },
            ],
            'KIND ': [
                {
                    data: -7566440,
                    unit: '',
                },
            ],
            'MCKEE FOODS CORPORATION ': [
                {
                    data: -1739517,
                    unit: '',
                },
            ],
            'MONDELEZ INTERNATIONAL INC ': [
                {
                    data: 13301260,
                    unit: '',
                },
            ],
            'ABBOTT LABORATORIES INC ': [
                {
                    data: -1776212,
                    unit: '',
                },
            ],
            'GLANBIA PLC ': [
                {
                    data: -1420321,
                    unit: '',
                },
            ],
            'THE SIMPLY GOOD FOODS COMPANY ': [
                {
                    data: 2949507,
                    unit: '',
                },
            ],
            'BELLA FOUR BAKERY/SONDA FOODS ': [
                {
                    data: -1555004,
                    unit: '',
                },
            ],
            'ATKINS ': [
                {
                    data: -1147052,
                    unit: '',
                },
            ],
            'WORLDWIDE SPORTS NUTRITION ': [
                {
                    data: 2152037,
                    unit: '',
                },
            ],
            'BIONUTRITIONAL RESEARCH GROUP ': [
                {
                    data: -1071371,
                    unit: '',
                },
            ],
            'THE HAIN CELESTIAL GROUP INC ': [
                {
                    data: 2792036,
                    unit: '',
                },
            ],
            'RIVERSIDE NATURAL FOODS LTD ': [
                {
                    data: 265525,
                    unit: '',
                },
            ],
            'SIMPLY DELICIOUS INC ': [
                {
                    data: 336014,
                    unit: '',
                },
            ],
            'GOMACRO LLC ': [
                {
                    data: 759070,
                    unit: '',
                },
            ],
            'PERVINE FOODS LLC ': [
                {
                    data: 855846,
                    unit: '',
                },
            ],
            'THATS IT NUTRITION LLC ': [
                {
                    data: 226418,
                    unit: '',
                },
            ],
            'BAKER MILLS ': [
                {
                    data: 770881,
                    unit: '',
                },
            ],
            'ALANI NUTRITION LLC ': [
                {
                    data: 1822558,
                    unit: '',
                },
            ],
            'DS NATURALS LLC ': [
                {
                    data: -148712,
                    unit: '',
                },
            ],
            "LENNY AND LARRY'S ": [
                {
                    data: 960512,
                    unit: '',
                },
            ],
            'FLOWERS FOODS LLC ': [
                {
                    data: 1365370,
                    unit: '',
                },
            ],
            'MET-RX NUTRITION INC ': [
                {
                    data: 364080,
                    unit: '',
                },
            ],
            'PROMAX ': [
                {
                    data: 472823,
                    unit: '',
                },
            ],
            'POST HOLDINGS INC ': [
                {
                    data: 1019160,
                    unit: '',
                },
            ],
            'CAMPBELL SOUP CO ': [
                {
                    data: 909052,
                    unit: '',
                },
            ],
            'LIFESTYLE EVOLUTION ': [
                {
                    data: 67810,
                    unit: '',
                },
            ],
            'WW INTERNATIONAL INC ': [
                {
                    data: 1141816,
                    unit: '',
                },
            ],
            'THE HERSHEY COMPANY ': [
                {
                    data: -580583,
                    unit: '',
                },
            ],
            'UNILEVER ': [
                {
                    data: -3214474,
                    unit: '',
                },
            ],
            'TINO KAI LLC ': [
                {
                    data: 527524,
                    unit: '',
                },
            ],
            'JUNKLESS FOODS ': [
                {
                    data: 718116,
                    unit: '',
                },
            ],
            "BOB'S RED MILL NTRL FOODS ": [
                {
                    data: 498043,
                    unit: '',
                },
            ],
            'NUTRITION BAR CONFECTIONERS ': [
                {
                    data: -244902,
                    unit: '',
                },
            ],
            'GRAB THE GOLD INC ': [
                {
                    data: -42610,
                    unit: '',
                },
            ],
            'CORE FOODS ': [
                {
                    data: 13361,
                    unit: '',
                },
            ],
            'ARTISAN CONFECTIONS COMPANY ': [
                {
                    data: 294535,
                    unit: '',
                },
            ],
            'MUNK PACK ': [
                {
                    data: -95758,
                    unit: '',
                },
            ],
            'SOUTH 40 SNACKS LLC ': [
                {
                    data: 361951,
                    unit: '',
                },
            ],
            'ALOHA ': [
                {
                    data: 334385,
                    unit: '',
                },
            ],
            'PAMELAS PRODUCTS INC ': [
                {
                    data: 333422,
                    unit: '',
                },
            ],
            'IQ BAR ': [
                {
                    data: 179058,
                    unit: '',
                },
            ],
            'UNDERCOVER CHOCOLATE CO LLC ': [
                {
                    data: -190061,
                    unit: '',
                },
            ],
            'SIMPLE MILLS ': [
                {
                    data: -8900,
                    unit: '',
                },
            ],
            'VERB ENERGY INC ': [
                {
                    data: 204100,
                    unit: '',
                },
            ],
            'BUILT BRANDS LLC ': [
                {
                    data: 189415,
                    unit: '',
                },
            ],
            'GOOD MEASURE ': [
                {
                    data: 168720,
                    unit: '',
                },
            ],
            'ENER G FOODS ': [
                {
                    data: -4653,
                    unit: '',
                },
            ],
            'THIS BAR SAVES LIVES LLC ': [
                {
                    data: 152861,
                    unit: '',
                },
            ],
            'KRISP NUTRITION ': [
                {
                    data: 149459,
                    unit: '',
                },
            ],
            'BLAKES SEED BASED LLC ': [
                {
                    data: 25076,
                    unit: '',
                },
            ],
            '1ST PHORM ': [
                {
                    data: 129396,
                    unit: '',
                },
            ],
            'VITAL PROTEINS LLC ': [
                {
                    data: 103927,
                    unit: '',
                },
            ],
            'TRAM BAR LLC ': [
                {
                    data: 91504,
                    unit: '',
                },
            ],
            'KISS MY KETO LLC ': [
                {
                    data: -40759,
                    unit: '',
                },
            ],
            'WEST THOMAS PARTNERS LLC ': [
                {
                    data: -268592,
                    unit: '',
                },
            ],
        },
        {
            type: '% Change',
            'TOTAL ': [
                {
                    data: -1.38,
                    unit: '%',
                },
            ],
            'GENERAL MILLS ': [
                {
                    data: 3.25,
                    unit: '%',
                },
            ],
            'PRIVATE LABEL ': [
                {
                    data: -11.41,
                    unit: '%',
                },
            ],
            'KELLOGGS ': [
                {
                    data: -14.37,
                    unit: '%',
                },
            ],
            'PEPSICO ': [
                {
                    data: 18.8,
                    unit: '%',
                },
            ],
            'CLIF ': [
                {
                    data: -12.24,
                    unit: '%',
                },
            ],
            'KIND ': [
                {
                    data: -9.87,
                    unit: '%',
                },
            ],
            'MCKEE FOODS CORPORATION ': [
                {
                    data: -3.35,
                    unit: '%',
                },
            ],
            'MONDELEZ INTERNATIONAL INC ': [
                {
                    data: 66.6,
                    unit: '%',
                },
            ],
            'ABBOTT LABORATORIES INC ': [
                {
                    data: -8.64,
                    unit: '%',
                },
            ],
            'GLANBIA PLC ': [
                {
                    data: -8,
                    unit: '%',
                },
            ],
            'THE SIMPLY GOOD FOODS COMPANY ': [
                {
                    data: 23.63,
                    unit: '%',
                },
            ],
            'BELLA FOUR BAKERY/SONDA FOODS ': [
                {
                    data: -9.96,
                    unit: '%',
                },
            ],
            'ATKINS ': [
                {
                    data: -7.98,
                    unit: '%',
                },
            ],
            'WORLDWIDE SPORTS NUTRITION ': [
                {
                    data: 21.91,
                    unit: '%',
                },
            ],
            'BIONUTRITIONAL RESEARCH GROUP ': [
                {
                    data: -10.26,
                    unit: '%',
                },
            ],
            'THE HAIN CELESTIAL GROUP INC ': [
                {
                    data: 79.82,
                    unit: '%',
                },
            ],
            'RIVERSIDE NATURAL FOODS LTD ': [
                {
                    data: 5.55,
                    unit: '%',
                },
            ],
            'SIMPLY DELICIOUS INC ': [
                {
                    data: 7.17,
                    unit: '%',
                },
            ],
            'GOMACRO LLC ': [
                {
                    data: 25.86,
                    unit: '%',
                },
            ],
            'PERVINE FOODS LLC ': [
                {
                    data: 40.51,
                    unit: '%',
                },
            ],
            'THATS IT NUTRITION LLC ': [
                {
                    data: 10.77,
                    unit: '%',
                },
            ],
            'BAKER MILLS ': [
                {
                    data: 53.64,
                    unit: '%',
                },
            ],
            'ALANI NUTRITION LLC ': [
                {
                    data: 817.76,
                    unit: '%',
                },
            ],
            'DS NATURALS LLC ': [
                {
                    data: -8.97,
                    unit: '%',
                },
            ],
            "LENNY AND LARRY'S ": [
                {
                    data: 207.16,
                    unit: '%',
                },
            ],
            'FLOWERS FOODS LLC ': [
                {
                    data: 46759.25,
                    unit: '%',
                },
            ],
            'MET-RX NUTRITION INC ': [
                {
                    data: 37.51,
                    unit: '%',
                },
            ],
            'PROMAX ': [
                {
                    data: 58.98,
                    unit: '%',
                },
            ],
            'POST HOLDINGS INC ': [
                {
                    data: 449.12,
                    unit: '%',
                },
            ],
            'CAMPBELL SOUP CO ': [
                {
                    data: 269.88,
                    unit: '%',
                },
            ],
            'LIFESTYLE EVOLUTION ': [
                {
                    data: 6.18,
                    unit: '%',
                },
            ],
            'WW INTERNATIONAL INC ': [
                {
                    data: 25774.63,
                    unit: '%',
                },
            ],
            'THE HERSHEY COMPANY ': [
                {
                    data: -36.56,
                    unit: '%',
                },
            ],
            'UNILEVER ': [
                {
                    data: -79.49,
                    unit: '%',
                },
            ],
            'TINO KAI LLC ': [
                {
                    data: 190.73,
                    unit: '%',
                },
            ],
            'JUNKLESS FOODS ': [
                {
                    data: 202857.63,
                    unit: '%',
                },
            ],
            "BOB'S RED MILL NTRL FOODS ": [
                {
                    data: 324.42,
                    unit: '%',
                },
            ],
            'NUTRITION BAR CONFECTIONERS ': [
                {
                    data: -31.06,
                    unit: '%',
                },
            ],
            'GRAB THE GOLD INC ': [
                {
                    data: -7.43,
                    unit: '%',
                },
            ],
            'CORE FOODS ': [
                {
                    data: 3.03,
                    unit: '%',
                },
            ],
            'ARTISAN CONFECTIONS COMPANY ': [
                {
                    data: 283.28,
                    unit: '%',
                },
            ],
            'MUNK PACK ': [
                {
                    data: -20.71,
                    unit: '%',
                },
            ],
            'SOUTH 40 SNACKS LLC ': [
                {
                    data: 0,
                    unit: '%',
                },
            ],
            'ALOHA ': [
                {
                    data: 16948.05,
                    unit: '%',
                },
            ],
            'PAMELAS PRODUCTS INC ': [
                {
                    data: 23815.86,
                    unit: '%',
                },
            ],
            'IQ BAR ': [
                {
                    data: 120.2,
                    unit: '%',
                },
            ],
            'UNDERCOVER CHOCOLATE CO LLC ': [
                {
                    data: -38.34,
                    unit: '%',
                },
            ],
            'SIMPLE MILLS ': [
                {
                    data: -3.45,
                    unit: '%',
                },
            ],
            'VERB ENERGY INC ': [
                {
                    data: 0,
                    unit: '%',
                },
            ],
            'BUILT BRANDS LLC ': [
                {
                    data: 29642.41,
                    unit: '%',
                },
            ],
            'GOOD MEASURE ': [
                {
                    data: 1597.12,
                    unit: '%',
                },
            ],
            'ENER G FOODS ': [
                {
                    data: -2.86,
                    unit: '%',
                },
            ],
            'THIS BAR SAVES LIVES LLC ': [
                {
                    data: 0,
                    unit: '%',
                },
            ],
            'KRISP NUTRITION ': [
                {
                    data: 32776.1,
                    unit: '%',
                },
            ],
            'BLAKES SEED BASED LLC ': [
                {
                    data: 22.79,
                    unit: '%',
                },
            ],
            '1ST PHORM ': [
                {
                    data: 0,
                    unit: '%',
                },
            ],
            'VITAL PROTEINS LLC ': [
                {
                    data: 408.6,
                    unit: '%',
                },
            ],
            'TRAM BAR LLC ': [
                {
                    data: 251.63,
                    unit: '%',
                },
            ],
            'KISS MY KETO LLC ': [
                {
                    data: -25.71,
                    unit: '%',
                },
            ],
            'WEST THOMAS PARTNERS LLC ': [
                {
                    data: -72.39,
                    unit: '%',
                },
            ],
        },
    ],
    level1DrillDownData: {
        minVal: -40176.04,
        maxVal: 1719518.2218901662,
        data: [
            {
                sales: -40176.04,
                labelSales: -40176.04,
                category: 'Seasonality',
                color: '#CA3D3D',
            },
            {
                sales: 1719518.2218901662,
                labelSales: 1719518.2218901662,
                category: 'Discount',
                color: '#42A531',
            },
            {
                sales: 913918.4168538067,
                labelSales: 913918.4168538067,
                category: 'Feature',
                color: '#42A531',
            },
            {
                sales: 91286.00319998445,
                labelSales: 91286.00319998445,
                category: 'Display',
                color: '#42A531',
            },
            {
                sales: 1247428.547594768,
                labelSales: 1247428.547594768,
                category: 'Feature & Display',
                color: '#42A531',
            },
        ],
    },
    infiniteSalesData: {
        data: [
            {
                sales: 105332167,
                labelSales: 105332167,
                category: 'TOTAL',
                color: '#42A531',
                disableHover: true,
            },
            {
                sales: -5473739,
                labelSales: -5473739,
                category: 'GENERAL MILLS',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -25232574,
                labelSales: -25232574,
                category: 'PRIVATE LABEL',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 33693345,
                labelSales: 33693345,
                category: 'KELLOGGS',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -5428657,
                labelSales: -5428657,
                category: 'PEPSICO',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -17144937,
                labelSales: -17144937,
                category: 'CLIF',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -16184756,
                labelSales: 16184756,
                category: 'KIND',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -1424588,
                labelSales: -1424588,
                category: 'MCKEE FOODS CORPORATION',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -3479374,
                labelSales: -3479374,
                category: 'MONDELEZ INTERNATIONAL INC',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -2768252,
                labelSales: -2768252,
                category: 'ABBOTT LABORATORIES INC',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -864459,
                labelSales: -864459,
                category: 'GLANBIA PLC',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 826917,
                labelSales: 826917,
                category: 'THE SIMPLY GOOD FOODS COMPANY',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -1334176,
                labelSales: -1334176,
                category: 'BELLA FOUR BAKERY/SONDA FOODS',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -1778742,
                labelSales: -1778742,
                category: 'ATKINS',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 1846587,
                labelSales: 1846587,
                category: 'WORLDWIDE SPORTS NUTRITION',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -1458274,
                labelSales: -1458274,
                category: 'BIONUTRITIONAL RESEARCH GROUP',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 376085,
                labelSales: 376085,
                category: 'SIMPLY DELICIOUS INC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -251974,
                labelSales: -251974,
                category: 'RIVERSIDE NATURAL FOODS LTD',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 459799,
                labelSales: 459799,
                category: 'GOMACRO LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 950816,
                labelSales: 950816,
                category: 'PERVINE FOODS LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 938159,
                labelSales: 938159,
                category: 'BAKER MILLS',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 81376,
                labelSales: 81376,
                category: 'THATS IT NUTRITION LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 1421656,
                labelSales: 1421656,
                category: 'ALANI NUTRITION LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 1294553,
                labelSales: 1294553,
                category: 'FLOWERS FOODS LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 652332,
                labelSales: 652332,
                category: "LENNY AND LARRY'S",
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -381640,
                labelSales: -381640,
                category: 'DS NATURALS LLC',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 337209,
                labelSales: 337209,
                category: 'PROMAX',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 218365,
                labelSales: 218365,
                category: 'MET-RX NUTRITION INC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 540623,
                labelSales: 540623,
                category: 'CAMPBELL SOUP CO',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 1034473,
                labelSales: 1034473,
                category: 'WW INTERNATIONAL INC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 67832,
                labelSales: 67832,
                category: 'LIFESTYLE EVOLUTION',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -430466,
                labelSales: -430466,
                category: 'THE HERSHEY COMPANY',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 581852,
                labelSales: 581852,
                category: 'POST HOLDINGS INC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 735287,
                labelSales: 735287,
                category: 'JUNKLESS FOODS',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 297610,
                labelSales: 297610,
                category: 'TINO KAI LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 529385,
                labelSales: 529385,
                category: "BOB'S RED MILL NTRL FOODS",
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -2694741,
                labelSales: -2694741,
                category: 'UNILEVER',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -32230,
                labelSales: -32230,
                category: 'GRAB THE GOLD INC',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -298843,
                labelSales: -298843,
                category: 'NUTRITION BAR CONFECTIONERS',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 459964,
                labelSales: 459964,
                category: 'SOUTH 40 SNACKS LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -57374,
                labelSales: -57374,
                category: 'CORE FOODS',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 378782,
                labelSales: 378782,
                category: 'ALOHA',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 183120,
                labelSales: 183120,
                category: 'ARTISAN CONFECTIONS COMPANY',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 309018,
                labelSales: 309018,
                category: 'PAMELAS PRODUCTS INC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -199602,
                labelSales: -199602,
                category: 'MUNK PACK',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 98327,
                labelSales: 98327,
                category: 'IQ BAR',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 277261,
                labelSales: 277261,
                category: 'VERB ENERGY INC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 215695,
                labelSales: 215695,
                category: 'THIS BAR SAVES LIVES LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 270516,
                labelSales: 270516,
                category: 'HEALTHY FOOD BRANDS/THE HFB CANDY CO',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 244965,
                labelSales: 244965,
                category: 'GOOD MEASURE',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -679,
                labelSales: -679,
                category: 'SIMPLE MILLS',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 210345,
                labelSales: 210345,
                category: 'BUILT BRANDS LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -5667,
                labelSales: -5667,
                category: 'ENER G FOODS',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: 140564,
                labelSales: 140564,
                category: '1ST PHORM',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 128994,
                labelSales: 128994,
                category: 'KRISP NUTRITION',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 25463,
                labelSales: 25463,
                category: 'BLAKES SEED BASED LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 102229,
                labelSales: 102229,
                category: 'TRAM BAR LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 112716,
                labelSales: 112716,
                category: 'VITAL PROTEINS LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: 112482,
                labelSales: 112482,
                category: 'INLAND COFFEE RETAILERS LLC',
                color: '#42A531',
                disableHover: false,
            },
            {
                sales: -173913,
                labelSales: -173913,
                category: 'UNDERCOVER CHOCOLATE CO LLC',
                color: '#CA3D3D',
                disableHover: false,
            },
            {
                sales: -211742,
                labelSales: -211742,
                category: 'WEST THOMAS PARTNERS LLC',
                color: '#CA3D3D',
                disableHover: false,
            },
        ],
        minVal: -105332167,
        maxVal: 105332167,
    },
    salesAttributionFeatureLevelData: {
        minVal: {
            abs: -63592329.74357357,
            percentage: -5.21393674125281,
        },
        maxVal: {
            abs: 63174555.95,
            percentage: 5.179683457238382,
        },
        data: {
            abs: [
                {
                    sales: 63174555.95,
                    labelSales: 63174555.95,
                    category: 'Mock Launch Plus Delist',
                    color: '#42A531',
                },
                {
                    sales: 21990966.257165108,
                    labelSales: 21990966.257165108,
                    category: 'Average No Of Items',
                    color: '#42A531',
                },
                {
                    sales: -63592329.74357357,
                    labelSales: -63592329.74357357,
                    category: 'Own Price',
                    color: '#CA3D3D',
                },
                {
                    sales: 27446724.019159496,
                    labelSales: 27446724.019159496,
                    category: 'Distribution Acv',
                    color: '#42A531',
                },
            ],
            percentage: [
                {
                    sales: 5.179683457238382,
                    labelSales: 5.179683457238382,
                    category: 'Mock Launch Plus Delist',
                    color: '#42A531',
                },
                {
                    sales: 1.8030398855684489,
                    labelSales: 1.8030398855684489,
                    category: 'Average No Of Items',
                    color: '#42A531',
                },
                {
                    sales: -5.21393674125281,
                    labelSales: -5.21393674125281,
                    category: 'Own Price',
                    color: '#CA3D3D',
                },
                {
                    sales: 2.2503576039370294,
                    labelSales: 2.2503576039370294,
                    category: 'Distribution Acv',
                    color: '#42A531',
                },
            ],
        },
    },
    lineChartResult: {
        minVal: 0,
        maxVal: 74922,
        data: [
            {
                period: '01/02/23',
                'Current Year': 53412,
                'Year Ago': 22500,
            },
            {
                period: '01/09/23',
                'Current Year': 66912,
                'Year Ago': 29238,
            },
            {
                period: '01/16/23',
                'Current Year': 70638,
                'Year Ago': 33390,
            },
            {
                period: '01/23/23',
                'Current Year': 70752,
                'Year Ago': 31302,
            },
            {
                period: '01/30/23',
                'Current Year': 74514.12,
                'Year Ago': 35976,
            },
            {
                period: '02/06/23',
                'Current Year': 68112.06,
                'Year Ago': 37326,
            },
            {
                period: '02/13/23',
                'Current Year': 59266.98,
                'Year Ago': 39636,
            },
            {
                period: '02/20/23',
                'Current Year': 60614.28,
                'Year Ago': 32220,
            },
            {
                period: '02/27/23',
                'Current Year': 64062.54,
                'Year Ago': 30378,
            },
            {
                period: '03/06/23',
                'Current Year': 63425.82,
                'Year Ago': 31722,
            },
            {
                period: '03/13/23',
                'Current Year': 59924.58,
                'Year Ago': 31056,
            },
            {
                period: '03/20/23',
                'Current Year': 59844.36,
                'Year Ago': 30756,
            },
            {
                period: '03/27/23',
                'Current Year': 58782,
                'Year Ago': 31440,
            },
            {
                period: '04/03/23',
                'Current Year': 63048,
                'Year Ago': 30690,
            },
            {
                period: '04/10/23',
                'Current Year': 55348.5,
                'Year Ago': 31956,
            },
            {
                period: '04/17/23',
                'Current Year': 60218.1,
                'Year Ago': 32370,
            },
            {
                period: '04/24/23',
                'Current Year': 57836.46,
                'Year Ago': 29370,
            },
            {
                period: '05/01/23',
                'Current Year': 56970,
                'Year Ago': 33846,
            },
            {
                period: '05/08/23',
                'Current Year': 68166,
                'Year Ago': 33366,
            },
            {
                period: '05/15/23',
                'Current Year': 72690,
                'Year Ago': 30270,
            },
            {
                period: '05/22/23',
                'Current Year': 64944,
                'Year Ago': 30096,
            },
            {
                period: '05/29/23',
                'Current Year': 63882,
                'Year Ago': 28974,
            },
            {
                period: '06/05/23',
                'Current Year': 57252,
                'Year Ago': 28572,
            },
            {
                period: '06/12/23',
                'Current Year': 51222,
                'Year Ago': 31080,
            },
            {
                period: '06/19/23',
                'Current Year': 47268,
                'Year Ago': 36564,
            },
            {
                period: '06/26/23',
                'Current Year': 50370,
                'Year Ago': 41526,
            },
            {
                period: '07/03/23',
                'Current Year': 45366,
                'Year Ago': 40092,
            },
            {
                period: '07/10/23',
                'Current Year': 52734,
                'Year Ago': 34020,
            },
            {
                period: '07/17/23',
                'Current Year': 59832,
                'Year Ago': 39060,
            },
            {
                period: '07/24/23',
                'Current Year': 69414,
                'Year Ago': 48234,
            },
            {
                period: '07/31/23',
                'Current Year': 69570,
                'Year Ago': 56058,
            },
            {
                period: '08/07/23',
                'Current Year': 68027.76,
                'Year Ago': 62850,
            },
            {
                period: '08/14/23',
                'Current Year': 65573.88,
                'Year Ago': 64698,
            },
            {
                period: '08/21/23',
                'Current Year': 59961.84,
                'Year Ago': 62610,
            },
            {
                period: '08/28/23',
                'Current Year': 57276,
                'Year Ago': 52530,
            },
            {
                period: '09/04/23',
                'Current Year': 57240,
                'Year Ago': 53562,
            },
            {
                period: '09/11/23',
                'Current Year': 56238,
                'Year Ago': 52110,
            },
            {
                period: '09/18/23',
                'Current Year': 58106.64,
                'Year Ago': 55434,
            },
            {
                period: '09/25/23',
                'Current Year': 55297.92,
                'Year Ago': 55794,
            },
            {
                period: '10/02/23',
                'Current Year': 55188.24,
                'Year Ago': 54966,
            },
            {
                period: '10/09/23',
                'Current Year': 51384,
                'Year Ago': 54132,
            },
            {
                period: '10/16/23',
                'Current Year': 61158,
                'Year Ago': 52410,
            },
            {
                period: '10/23/23',
                'Current Year': 66108,
                'Year Ago': 62682,
            },
            {
                period: '10/30/23',
                'Current Year': 59885.65,
                'Year Ago': 70758,
            },
            {
                period: '11/06/23',
                'Current Year': 61847.9,
                'Year Ago': 61626,
            },
            {
                period: '11/13/23',
                'Current Year': 55745.46,
                'Year Ago': 61680,
            },
            {
                period: '11/20/23',
                'Current Year': 38520,
                'Year Ago': 55662,
            },
            {
                period: '11/27/23',
                'Current Year': 62238,
                'Year Ago': 36462,
            },
            {
                period: '12/04/23',
                'Current Year': 68286,
                'Year Ago': 65160,
            },
            {
                period: '12/11/23',
                'Current Year': 62868,
                'Year Ago': 74922,
            },
            {
                period: '12/18/23',
                'Current Year': 47574,
                'Year Ago': 66894,
            },
            {
                period: '12/25/23',
                'Current Year': 29778,
                'Year Ago': 50706,
            },
        ],
    },
    tableData: [
        {
            row_label: 'row name 1',
            columns: [
                {
                    column_label: 'KPI 1',
                    value: 5,
                },
                {
                    column_label: 'KPI 2',
                    value: 64,
                },
                {
                    column_label: 'KPI 3',
                    value: 21,
                },
                {
                    column_label: 'KPI 4',
                    value: 73,
                },
                {
                    column_label: 'KPI 5',
                    value: 14,
                },
                {
                    column_label: 'KPI 6',
                    value: 28,
                },
                {
                    column_label: 'KPI 7',
                    value: 19,
                },
                {
                    column_label: 'KPI 8',
                    value: 29,
                },
                {
                    column_label: 'KPI 9',
                    value: 97,
                },
                {
                    column_label: 'KPI 10',
                    value: 24,
                },
            ],
        },
        {
            row_label: 'row name 2',
            columns: [
                {
                    column_label: 'KPI 1',
                    value: 90,
                },
                {
                    column_label: 'KPI 2',
                    value: 54,
                },
                {
                    column_label: 'KPI 3',
                    value: 46,
                },
                {
                    column_label: 'KPI 4',
                    value: 4,
                },
                {
                    column_label: 'KPI 5',
                    value: 55,
                },
                {
                    column_label: 'KPI 6',
                    value: 72,
                },
                {
                    column_label: 'KPI 7',
                    value: 27,
                },
                {
                    column_label: 'KPI 8',
                    value: 96,
                },
                {
                    column_label: 'KPI 9',
                    value: 11,
                },
                {
                    column_label: 'KPI 10',
                    value: 67,
                },
            ],
        },
        {
            row_label: 'row name 3',
            columns: [
                {
                    column_label: 'KPI 1',
                    value: 57,
                },
                {
                    column_label: 'KPI 2',
                    value: 1,
                },
                {
                    column_label: 'KPI 3',
                    value: 61,
                },
                {
                    column_label: 'KPI 4',
                    value: 84,
                },
                {
                    column_label: 'KPI 5',
                    value: 39,
                },
                {
                    column_label: 'KPI 6',
                    value: 20,
                },
                {
                    column_label: 'KPI 7',
                    value: 61,
                },
                {
                    column_label: 'KPI 8',
                    value: 92,
                },
                {
                    column_label: 'KPI 9',
                    value: 0,
                },
                {
                    column_label: 'KPI 10',
                    value: 14,
                },
            ],
        },
        {
            row_label: 'row name 4',
            columns: [
                {
                    column_label: 'KPI 1',
                    value: 0,
                },
                {
                    column_label: 'KPI 2',
                    value: 37,
                },
                {
                    column_label: 'KPI 3',
                    value: 15,
                },
                {
                    column_label: 'KPI 4',
                    value: 49,
                },
                {
                    column_label: 'KPI 5',
                    value: 9,
                },
                {
                    column_label: 'KPI 6',
                    value: 40,
                },
                {
                    column_label: 'KPI 7',
                    value: 34,
                },
                {
                    column_label: 'KPI 8',
                    value: 93,
                },
                {
                    column_label: 'KPI 9',
                    value: 18,
                },
                {
                    column_label: 'KPI 10',
                    value: 92,
                },
            ],
        },
    ],
};

//category sales vs ya data
export const categorySalesVsYaChartData = [
    [
        {
            sales: 4,
            category: 'kigging',
            color: colorConstants.violet,
            disableHover: true,
        },
    ],
    [
        {
            sales: -2,
            category: 'dash',
            color: colorConstants.red,
            disableHover: false,
        },
    ],
    [
        {
            sales: -2,
            category: 'kind',
            color: colorConstants.red,
            disableHover: false,
        },
    ],
    [
        {
            sales: -2,
            category: 'qwfg',
            color: colorConstants.red,
            disableHover: false,
        },
    ],
    [
        {
            sales: 1,
            category: 'wff',
            color: colorConstants.limeGreen,
            disableHover: false,
        },
    ],
];

//ppg sales vs ya data
export const ppgVsYaChartData = [
    {
        sales: 10,
        category: 'asdd',
        color: colorConstants.limeGreen,
    },
    {
        sales: 4,
        category: 'kiggingd',
        color: colorConstants.limeGreen,
    },
    {
        sales: -7,
        category: 'asdas',
        color: colorConstants.red,
    },
    {
        sales: -7,
        category: 'kind',
        color: colorConstants.red,
    },
    {
        sales: -7,
        category: 'asgh',
        color: colorConstants.red,
    },
    {
        sales: -7,
        category: 'xcv',
        color: colorConstants.red,
    },
    {
        sales: -7,
        category: 'asduioyiuoas',
        color: colorConstants.red,
    },
    {
        sales: -7,
        category: 'erererr',
        color: colorConstants.red,
    },
    {
        sales: -7,
        category: 'fffgfg',
        color: colorConstants.red,
    },
    {
        sales: 11,
        category: 'qweqwe',
        color: colorConstants.limeGreen,
    },
    {
        sales: -4,
        category: 'ghfgh',
        color: colorConstants.red,
    },
    {
        sales: -2,
        category: 'ghsssfgh',
        color: colorConstants.red,
    },
];

//brand level vs ya grouped chart
export const brandLevelGroupedChartData = [
    {
        sales: 11,
        type: 'base',
        category: 'asdd',
        color: colorConstants.limeGreen,
    },
    {
        sales: 10,
        type: 'incremental',
        category: 'asdd',
        color: colorConstants.red,
    },
    {
        sales: 14,
        type: 'base',
        category: 'kind',
        color: colorConstants.limeGreen,
    },
    {
        sales: 1,
        type: 'base',
        category: 'kindfg',
        color: colorConstants.limeGreen,
    },
    {
        sales: 4,
        category: 'kiggingd',
        type: 'base',
        color: colorConstants.limeGreen,
    },
    {
        sales: -7,
        category: 'asdas',
        color: colorConstants.limeGreen,
        type: 'base',
    },
    {
        sales: 11,
        category: 'qweqwe',
        color: colorConstants.limeGreen,
        type: 'base',
    },
    {
        sales: -4,
        category: 'ghfgh',
        color: colorConstants.limeGreen,
        type: 'base',
    },

    {
        sales: 14,
        type: 'incremental',
        category: 'kind',
        color: colorConstants.red,
    },
    {
        sales: 1,
        type: 'incremental',
        category: 'kindfg',
        color: colorConstants.red,
    },
    {
        sales: 4,
        category: 'kiggingd',
        type: 'incremental',
        color: colorConstants.red,
    },
    {
        sales: -1,
        category: 'asdas',
        color: colorConstants.red,
        type: 'incremental',
    },
    {
        sales: 14,
        category: 'qweqwe',
        color: colorConstants.red,
        type: 'incremental',
    },
    {
        sales: -3,
        category: 'ghfgh',
        color: colorConstants.red,
        type: 'incremental',
    },
];

//current year sales vs year ago column chart
export const currentYearSalesColumnChartData = [
    {
        sales: 10,
        category: 'w4',
        color: colorConstants.limeGreen,
    },
    {
        sales: 4,
        category: 'w12',
        color: colorConstants.limeGreen,
    },
    {
        sales: -7,
        category: 'w16',
        color: colorConstants.red,
    },
    {
        sales: 11,
        category: 'w36',
        color: colorConstants.limeGreen,
    },
    {
        sales: -4,
        category: 'w54',
        color: colorConstants.red,
    },
];

//current year sales vs year ago line chart
export const currentYearSalesLineChartData = [
    { period: 'w4', 'Current Year': 12, 'Year Ago': 5 },
    { period: 'w8', 'Current Year': 13, 'Year Ago': 2 },
    { period: 'w24', 'Current Year': 1, 'Year Ago': 6 },
    { period: 'w35', 'Current Year': 7, 'Year Ago': 12 },
    { period: 'w52', 'Current Year': 12, 'Year Ago': 5 },
];

//attribute sales data
export const attributeSalesData = [
    { scale: null, initial: null, sd: 6.2, execution: -13.5, promotion: 12.2, other_factors: 0.03, overall: -1.6 },
    {
        scale: [],
        initial: [{ type: '52 W/E August 12', change: [0, 141000] }],
        sd: [{ type: 'Structure Demand', change: [141000, 152000] }],
        execution: [
            { type: 'Avg. No Of Items', change: [152000, 148000] },
            { type: 'Own Distribution', change: [148000, 156000] },
            { type: 'Own Price', change: [156000, 141000] },
        ],
        promotion: [
            { type: 'TPR', change: [141000, 144000] },
            { type: 'Display', change: [144000, 132000] },
            { type: 'Feature', change: [132000, 130000] },
            { type: 'Feature & Display', change: [130000, 128000] },
        ],
        other_factors: [
            { type: 'Internal Comp. Price', change: [128000, 144000] },
            { type: 'Internal Comp. Distrib', change: [144000, 143000] },
            { type: 'External Comp. Price', change: [141000, 150000] },
            { type: 'External Comp. Distrib', change: [142000, 141000] },
        ],
        overall: [{ type: '52 W/E Dec 20', change: [0, 141000] }],
    },
    {
        scale: null,
        initial: null,
        sd: [6.2],
        execution: [-0.1, 0.2, -2.2],
        promotion: [-0.1, 0.2, -2.2, 1.1],
        other_factors: [-0.2, -0.02, 0.4, -0.1],
        overall: null,
    },
    // {
    //     initial: '',
    //     sd: '',
    //     execution: '',
    //     other_factors: '',
    //     unexplained: '',
    //     overall: '',
    // },
];

//attribute sales header data
export const headerTitle = ['', '', 'SD', 'Execution', 'Promotion', 'Other Factors', 'Overall'];

//growth analysis table data
export const growthAnalysisTableData = [
    {
        type: 'Volume Sales CY',
        'Manufacturer total': 1270,
        Kind: 124,
        Kindd: 124,
        Kinds: 124,
        Cliff: 4560,
        Larabar: 3454,
        Quest: 1234,
    },
    {
        type: 'Volume Sales YA',
        'Manufacturer total': 1670,
        Kind: 12234,
        Kindd: 12234,
        Kinds: 12234,
        Cliff: 4560,
        Larabar: 3454,
        Quest: 1234,
    },
    {
        type: 'Volume Sales Abs',
        'Manufacturer total': 1370,
        Kind: 1274,
        Kindd: 1274,
        Kinds: 1274,
        Cliff: 4560,
        Larabar: 3454,
        Quest: 1234,
    },
    {
        type: '% Change',
        'Manufacturer total': 110,
        Kind: 134,
        Kindd: 134,
        Kinds: 134,
        Cliff: 4560,
        Larabar: 3454,
        Quest: 1234,
    },
];

//promo scorecard questions table data
export const getScoreCardQuestionsTableData = (config: any) => {
    const promoScoreCardConfig = config?.promoScoreCard;
    return [
        {
            Questions: 'Am I getting my fair share of quality support? (Fair Share Index -$ Sold)',
            name: '',
            [promoScoreCardConfig?.promoTypeLabelMapping?.tpr?.label || 'TPR']: '120',

            [promoScoreCardConfig?.promoTypeLabelMapping?.display?.label || 'Display']: '140',
            [promoScoreCardConfig?.promoTypeLabelMapping?.feature?.label || 'Feature']: '20',
            [promoScoreCardConfig?.promoTypeLabelMapping?.feature_and_display?.label || 'Feature & Display']: '300',
            isExpandable: '',
            color: {
                TPR: colorConstants.lightGreen,
                Display: colorConstants.cream,
                Feature: colorConstants.lightRed,
                'Feature & Display': colorConstants.lightGreen,
            },
        },
        {
            Questions: 'How does my % Discount compare to competition? (Weighted Average % Price Reduction)',
            TPR: '10%',

            Display: '20%',
            Feature: '50%',
            'Feature & Display': '40%',
            color: {
                TPR: colorConstants.lightGreen,
                Display: colorConstants.cream,
                Feature: colorConstants.lightRed,
                'Feature & Display': colorConstants.lightGreen,
            },
        },
        {
            Questions: 'What % of Volume was sold on promotion? (% of Volume)',
            TPR: '10%',
            Display: '20%',
            Feature: '50%',
            'Feature & Display': '40%',
            color: {
                TPR: colorConstants.lightGreen,
                Display: colorConstants.cream,
                Feature: colorConstants.lightRed,
                'Feature & Display': colorConstants.lightGreen,
            },
        },
        {
            Questions: 'How many weeks am i promoting? (Weighted Weeks)',
            TPR: '10',
            Display: '20',
            Feature: '50',
            'Feature & Display': '40',
            color: {
                TPR: colorConstants.lightGreen,
                Display: colorConstants.cream,
                Feature: colorConstants.lightRed,
                'Feature & Display': colorConstants.lightGreen,
            },
        },
        {
            Questions: 'What is my average price/lbs? (Price per Volume)',
            TPR: '$10',

            Display: '$20',
            Feature: '$50',
            'Feature & Display': '$40',
            color: {
                TPR: colorConstants.lightGreen,
                Display: colorConstants.cream,
                Feature: colorConstants.lightRed,
                'Feature & Display': colorConstants.lightGreen,
            },
        },
        {
            Questions: 'What is my average price/units? (Price per Unit)',
            TPR: '$10',

            Display: '$20',
            Feature: '$50',
            'Feature & Display': '$40',
            color: {
                TPR: colorConstants.lightGreen,
                Display: colorConstants.cream,
                Feature: colorConstants.lightRed,
                'Feature & Display': colorConstants.lightGreen,
            },
        },
    ];
};

//promo scorecard brand graph data

export const scorecardBrandGraphData: any[] = [
    [
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'Display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 37,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
    ],
    ['Kind', 'asd', 'asd', 'asd', 'asd', 'asd'],
];
//promo scorecard promo graph data
export const scorecardPromoGraphData: any[] = [
    [
        [
            {
                discount: 40,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
        [
            {
                discount: 4,
                category: 'TPR',
                color: colorConstants.red,
            },
            {
                discount: 13,
                category: 'display',
                color: colorConstants.limeGreen,
            },
            {
                discount: 12,
                category: 'feature',
                color: colorConstants.orangeAlt,
            },
            {
                discount: 34,
                category: 'F&D',
                color: colorConstants.limeGreen,
            },
        ],
    ],
    ['TPR', 'Display', 'Feature', 'Feature & Display'],
];
//brand scorecard table data
export const scorecardBrandTableData: any[] = [
    {
        PPG: 'KIND PPG1',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG2',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG3',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG4',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG5',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
];

//promo scorecard table data
export const scorecardPromoTableData: any[] = [
    {
        PPG: 'KIND PPG1',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG14',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG13',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG11',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
    {
        PPG: 'KIND PPG12',
        'EQ Volume Lbs': 25000,
        'Total Sales $': 25000,
        TPR: 200,
        Feature: 2000,
        Display: 200,
        'Feature & Display': 200,
        color: {
            'EQ Volume Lbs': colorConstants.orangeAlt,
            'Total Sales $': colorConstants.red,
            TPR: colorConstants.limeGreen,
            Display: colorConstants.orangeAlt,
            Feature: colorConstants.red,
            'Feature & Display': colorConstants.limeGreen,
        },
    },
];

//promo bump report calender data

export const bumpReportData: any[] = [
    {
        ppg: '',
    },
    {
        ppg: 'ppg1',
        '01/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(300% - 50%)',
                    background: colorConstants.darkGreen,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '02/01/2022': [],
        '03/01/2022': [],
        '04/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '05/01/2022': [],
        '06/01/2022': [],
        '07/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkGreen,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '08/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkGreen,
                },
                shared: false,
            },
        ],
        '09/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '10/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '11/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '12/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '13/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '14/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
    },
    {
        ppg: 'ppg2',
        '01/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '02/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkGreen,
                },
                shared: false,
            },
        ],
        '03/01/2022': [],
        '04/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(170% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(130% - 50%)',
                    background: colorConstants.darkGreen,
                },
                shared: false,
            },
        ],
        '05/01/2022': [],
        '06/01/2022': [],
        '07/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '08/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '09/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '10/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '11/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkGreen,
                },
                shared: false,
            },
        ],
        '12/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '13/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '14/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
    },
    {
        ppg: 'ppg3',
        '01/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
            {
                style: {
                    marginLeft: '20%',
                    width: 'calc(100% - 20%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '02/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '03/01/2022': [
            {
                style: {
                    marginLeft: '40%',
                    width: 'calc(100% - 40%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '04/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '05/01/2022': [],
        '06/01/2022': [],
        '07/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '08/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '09/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '10/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '11/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '12/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '13/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '14/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
    },
    {
        ppg: 'ppg4',
        '01/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '02/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '03/01/2022': [],
        '04/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '05/01/2022': [],
        '06/01/2022': [],
        '07/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '08/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '09/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkOrange,
                },
                shared: false,
            },
        ],
        '10/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '11/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.purple,
                },
                shared: false,
            },
        ],
        '12/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '13/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
        '14/01/2022': [
            {
                style: {
                    marginLeft: '50%',
                    width: 'calc(100% - 50%)',
                    background: colorConstants.darkBlueAlt,
                },
                shared: false,
            },
        ],
    },
];

//bump chart (line + stacked)
export const bumpChartIncrementsStackedData = () => {
    // const limit= 312
    const limit = 104;
    const result: any = [];
    for (let i = 1; i <= limit; i++) {
        if (i <= limit / 2) {
            const obj = {
                sales: i + 1,
                type: 'Incremental',
                date: `${i}/01/2022`,
                color: colorConstants.darkGreenAlt,
                totalSales: i + 1 + (i + limit / 2 + 1),
                value: 15,
                index: i - 1,
            };
            result.push(obj);
        } else {
            const obj = {
                sales: i + 1,
                type: 'Base',
                date: `${Math.abs(i - limit / 2)}/01/2022`,
                color: colorConstants.darkGreen,
                value: null,
                index: i - 1,
            };
            result.push(obj);
        }
    }
    return result;
};
//bump chart (line + stacked)
export const bumpChartPromoStackedData = () => {
    // const limit= 156
    const limit = 52;
    const sections = 5;
    const result: any = [];
    for (let i = 1; i <= limit * sections; i++) {
        if (i <= limit) {
            const obj = {
                sales: i + 1,
                type: 'TPR',
                date: `${i}/01/2022`,
                color: colorConstants.darkGreenAlt,
                totalSales: i + 1 + (i + limit + 1),
                value: 15,
                index: i - 1,
            };
            result.push(obj);
        } else if (i <= limit * 2) {
            const obj = {
                sales: i + 1,
                type: 'Feature',
                date: `${Math.floor(Math.abs(i - limit))}/01/2022`,
                color: colorConstants.darkGreen,
                value: null,
                index: i - 1,
            };
            result.push(obj);
        } else if (i <= limit * 3) {
            const obj = {
                sales: i + 1,
                type: 'Display',
                date: `${Math.floor(Math.abs(i - limit * 2))}/01/2022`,
                color: colorConstants.darkGreen,
                value: null,
                index: i - 1,
            };
            result.push(obj);
        } else if (i <= limit * 4) {
            const obj = {
                sales: i + 1,
                type: 'F & D',
                date: `${Math.floor(Math.abs(i - limit * 3))}/01/2022`,
                color: colorConstants.darkGreen,
                value: null,
                index: i - 1,
            };
            result.push(obj);
        } else if (i <= limit * 5) {
            const obj = {
                sales: i + 1,
                type: 'Non Promo',
                date: `${Math.floor(Math.abs(i - limit * 4))}/01/2022`,
                color: colorConstants.darkGreen,
                value: null,
                index: i - 1,
            };
            result.push(obj);
        }
    }
    return result;
};

//bump report comparison table
export const bumpReportComparisonTableData = (from: string) => {
    const result = [
        {
            PPG: from === 'incremental' ? 'Base' : 'Promo',
            'Abs Sales': 2417,
            '% Sales': '67%',
        },
        {
            PPG: from === 'incremental' ? 'Incremental' : 'Non-Promo',
            'Abs Sales': 1234,
            '% Sales': '55%',
        },
    ];
    return result;
};

export const dataBubbleChart: any = {
    PPG: [
        {
            xValue: 1,
            yValue: 8,
            category: 'MILKYWAY',
            size: 500,
            name: 'OH MLKWY 5H 92',
        },
        {
            xValue: 1.2,
            yValue: 8,
            category: 'MILKYWAY',
            size: 300,
            name: 'OH MLKWY 5H 92',
        },
        {
            xValue: 0.8,
            yValue: 6,
            category: 'MILKYWAY',
            size: 400,
            name: 'OH MLKWY 5H 92',
        },
        {
            xValue: 1.6,
            yValue: 4,
            category: 'MILKYWAY',
            size: 400,
            name: 'OH MLKWY 5H 92',
        },
        {
            xValue: 1.3,
            yValue: 7,
            category: 'SKITTLES',
            size: 500,
            name: 'MW SKITTLES P 200g',
        },
        {
            xValue: 0.7,
            yValue: 4,
            category: 'SKITTLES',
            size: 302,
            name: 'MW SKITTLES P 200g',
        },
        {
            xValue: 1.8,
            yValue: 6,
            category: 'SKITTLES',
            size: 410,
            name: 'MW SKITTLES P 200g',
        },
        {
            xValue: 1.5,
            yValue: 6,
            category: 'SKITTLES',
            size: 410,
            name: 'MW SKITTLES P 200g',
        },
        {
            xValue: 1.9,
            yValue: 4,
            category: 'SKITTLES',
            size: 410,
            name: 'MW SKITTLES P 200g',
        },
        {
            xValue: 1.8,
            yValue: 9,
            category: 'TWIX',
            size: 402,
            name: 'MW TWIX 5 H 80',
        },
        {
            xValue: 1.8,
            yValue: 9,
            category: 'TWIX',
            size: 402,
            name: 'MW TWIX 5 H 80',
        },
        {
            xValue: 1.2,
            yValue: 6,
            category: 'TWIX',
            size: 402,
            name: 'MW TWIX 5 H 80',
        },
        {
            xValue: 0.5,
            yValue: 3,
            category: 'TWIX',
            size: 502,
            name: 'MW TWIX 5 H 80',
        },
        {
            xValue: 1,
            yValue: 5,
            category: 'TWIX',
            size: 402,
            name: 'MW TWIX 5 H 80',
        },
        {
            xValue: 1.5,
            yValue: 5,
            category: 'TWIX',
            size: 502,
            name: 'MW TWIX 5 H 80',
        },
    ],
    Brand: [
        {
            xValue: 1.5,
            yValue: 7,
            category: 'MILKYWAY',
            size: 58,
            name: 'MILKYWAY',
        },
        {
            xValue: 1.2,
            yValue: 8,
            category: 'SKITTLES',
            size: 50,
            name: 'SKITTLES',
        },
        {
            xValue: 1.6,
            yValue: 5,
            category: 'TWIX',
            size: 40,
            name: 'TWIX',
        },
    ],
};

//portfolioAnalysis table data

export const portfolioAnalysisTableData = [
    {
        product: {
            data: 'core1',
            rowSpan: 4,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 2,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
            color: colorConstants.borderGreyAlt,
        },
        ROI: { data: 2.2 },
    },
    {
        product: {
            data: 'core1',
            rowSpan: 0,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 0,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
        },
        ROI: { data: 2.2, color: colorConstants.limeGreenAlt },
    },
    {
        product: {
            data: 'core1',
            rowSpan: 0,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 2,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
            color: colorConstants.borderGreyAlt,
        },
        ROI: { data: 2.2 },
    },
    {
        product: {
            data: 'core1',
            rowSpan: 0,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 0,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
        },
        ROI: { data: 2.2, color: colorConstants.limeGreenAlt },
    },
    {
        product: {
            data: 'core2',
            rowSpan: 4,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 1,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
            color: colorConstants.borderGreyAlt,
        },
        ROI: { data: 2.2 },
    },
    {
        product: {
            data: 'core2',
            rowSpan: 0,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 3,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
        },
        ROI: { data: 2.2, color: colorConstants.limeGreenAlt },
    },
    {
        product: {
            data: 'core2',
            rowSpan: 0,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 0,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
            color: colorConstants.borderGreyAlt,
        },
        ROI: { data: 2.2 },
    },
    {
        product: {
            data: 'core2',
            rowSpan: 0,
        },
        mechanics: {
            data: 'ads',
            rowSpan: 0,
        },
        tactic: { data: 'TPR' },
        'Tactic Wks': { data: 6 },
        Lift: {
            data: 2.2,
            color: colorConstants.borderGreyAlt,
        },
        ROI: { data: 2.2 },
    },
];

//portfolio analysis table header dropdown data
export const portfolioAnalysisTableHeaderData = {
    mechanics: [
        {
            key: 'select all',
            label: 'Select All',
            selected: true,
        },
        {
            key: 'core1',
            label: 'core 1',
            selected: true,
        },
        {
            key: 'core2',
            label: 'Core 2',
            selected: true,
        },
        {
            key: 'core3',
            label: 'Core 3',
            selected: true,
        },
        {
            key: 'core4',
            label: 'Core 4',
            selected: true,
        },
    ],
};

export const recommendationEventsListDummyData = [
    {
        Account: 'Kroger',
        'All Event': 'Kroger BOGO Jan',
        Products: ['ppg1', 'ppg2'],
        edit: true,
    },
    {
        Account: 'Kroger2',
        'All Event': 'Kroger 22 BOGO Jan',
        Products: ['ppgKroger2'],
        edit: true,
    },
    {
        Account: 'Kroger',
        'All Event': 'Kroger 3 BOGO Jan',
        Products: ['ppgKroger3', 'kro3', 'kro', 'fff', 'adsasd'],
        edit: true,
    },
    {
        Account: 'Kroger33',
        'All Event': 'Kroger 3 BOGO Jan',
        Products: ['ppgKroger3', 'kro3', 'kro', 'fff', 'adsasd'],
        edit: true,
    },
    {
        Account: 'Kroger12',
        'All Event': 'Kroger 3 BOGO Jan',
        Products: ['ppgKroger3', 'kro3', 'kro', 'fff', 'adsasd'],
        edit: true,
    },
];

export const bestWeeksDummyData = [
    {},
    {
        month: '1',
        periods: [1, 2, 3, 4],
        events: {
            1: [{ eventName: 'TN Year' }, { eventName: 'Pongal' }],
            2: [{ eventName: 'KA Year' }, { eventName: 'Sankranthi' }],
            4: [{ eventName: 'New Year' }, { eventName: 'Pongal' }, { eventName: 'Shiva Ratri' }],
        },
    },
    {
        month: 'Feb',
        periods: [5, 6, 7, 8],
        events: {
            6: [{ eventName: 'Valentines' }],
        },
    },
    {
        month: 'Mar',
        periods: [9, 10],
        events: {
            10: [{ eventName: 'Valentines' }],
        },
    },
    {
        month: 'Apr',
        periods: [11, 12, 13, 14, 15],
        events: {
            14: [{ eventName: 'Testing' }],
        },
    },
];

export const bestWeeksPpgData = [
    {},
    {
        attributeName: 'ppg1',
        values: {
            1: { val: 40, color: '#FFE3E3', isBordered: true },
            2: { val: 12, color: colorConstants.limeGreen, isBordered: false },
            3: { val: 34, color: colorConstants.limeGreen, isBordered: false },
            4: { val: 42, color: colorConstants.limeGreen, isBordered: true },
            5: { val: 23, color: '#F1F9E9', isBordered: false },
            6: { val: 45, color: colorConstants.red, isBordered: false },
            7: { val: 21, color: colorConstants.limeGreen, isBordered: false },
            8: { val: 31, color: colorConstants.limeGreen, isBordered: false },
            9: { val: 12, color: colorConstants.limeGreen, isBordered: true },
            10: { val: 2, color: colorConstants.limeGreen, isBordered: false },
            11: { val: 45, color: colorConstants.red, isBordered: false },
            12: { val: 21, color: colorConstants.limeGreen, isBordered: false },
            13: { val: 31, color: colorConstants.limeGreen, isBordered: false },
            14: { val: 12, color: colorConstants.limeGreen, isBordered: true },
            15: { val: 2, color: colorConstants.limeGreen, isBordered: false },
        },
    },
    {
        attributeName: 'ppg2',
        values: {
            1: { val: 40, color: colorConstants.lightRed, isBordered: true },
            2: { val: 12, color: colorConstants.lightRed, isBordered: false },
            3: { val: 34, color: colorConstants.limeGreen, isBordered: false },
            // 4: { val: 42, color: colorConstants.lightRed, isBordered: true },
            // 5: { val: 23, color: '#F1F9E9', isBordered: false },
            // 6: { val: 45, color: colorConstants.red, isBordered: false },
            7: { val: 21, color: colorConstants.lightRed, isBordered: false },
            8: { val: 31, color: colorConstants.lightRed, isBordered: false },
            9: { val: 12, color: colorConstants.limeGreen, isBordered: true },
            10: { val: 2, color: colorConstants.lightRed, isBordered: false },
            11: { val: 45, color: colorConstants.red, isBordered: false },
            12: { val: 21, color: colorConstants.lightRed, isBordered: false },
            13: { val: 31, color: colorConstants.limeGreen, isBordered: false },
            14: { val: 12, color: colorConstants.lightRed, isBordered: true },
            15: { val: 2, color: colorConstants.lightRed, isBordered: false },
        },
    },
];

export const initialLenses: Array<LenseConfig> = [
    {
        isAllSelected: false,
        lenseName: 'Sales',
        lenseId: 1,
        isRecentlyUsed: false,
        attributes: [
            {
                isSelected: false,
                name: 'Sales Attribute1',
                attributeId: 1,
                type: 'Cell',
                isEditable: true,
            },
            {
                isSelected: false,
                name: 'Sales Attribute2',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Sales Attribute3',
                attributeId: 1,
                type: 'Cell',
                isEditable: true,
            },
            {
                isSelected: false,
                name: 'Sales Attribute4',
                attributeId: 1,
                type: 'Checkbox',
                isEditable: true,
            },
            {
                isSelected: false,
                name: 'Sales Attribute5',
                attributeId: 1,
                type: 'Cell',
                isEditable: true,
            },
            {
                isSelected: false,
                name: 'Sales Attribute41',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Sales Attribute52',
                attributeId: 1,
                type: 'Cell',
            },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Elasticity',
        lenseId: 1,
        attributes: [
            {
                isSelected: false,
                name: 'Elasticity Attribute1',
                attributeId: 1,
                type: 'Cell',
            },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Promotions',
        lenseId: 1,
        attributes: [
            {
                isSelected: false,
                name: 'Promotions Attribute1',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Promotions Attribute2',
                attributeId: 1,
                type: 'Checkbox',
                isEditable: true,
            },
            {
                isSelected: false,
                name: 'Promotions Attribute3',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Promotions Attribute4',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Promotions Attribute5',
                attributeId: 1,
                type: 'Cell',
                isEditable: true,
            },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Cost of Goods',
        lenseId: 1,
        attributes: [
            {
                isSelected: false,
                name: 'Cost of Goods Attribute1',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Cost of Goods Attribute2',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Cost of Goods Attribute3',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Cost of Goods Attribute4',
                attributeId: 1,
                type: 'Checkbox',
                isEditable: true,
            },
            {
                isSelected: false,
                name: 'Cost of Goods Attribute5',
                attributeId: 1,
                type: 'Cell',
            },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Distribution',
        lenseId: 1,
        attributes: [
            {
                isSelected: false,
                name: 'Distribution Attribute1',
                attributeId: 1,
                type: 'Cell',
                isEditable: true,
            },
            {
                isSelected: false,
                name: 'Distribution Attribute2',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute3',
                attributeId: 1,
                type: 'Cell',
                isEditable: true,
            },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Distribution1',
        lenseId: 1,
        attributes: [
            {
                isSelected: false,
                name: 'Distribution Attribute1',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute2',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute3',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute4',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute5',
                attributeId: 1,
                type: 'Cell',
            },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Distribution12',
        lenseId: 1,
        attributes: [
            {
                isSelected: false,
                name: 'Distribution Attribute1',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute2',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute3',
                attributeId: 1,
                type: 'Cell',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute4',
                attributeId: 1,
                type: 'Checkbox',
            },
            {
                isSelected: false,
                name: 'Distribution Attribute5',
                attributeId: 1,
                type: 'Cell',
            },
        ],
    },
];

export const initialFilters: Array<LenseConfig> = [
    {
        isAllSelected: false,
        lenseName: 'Sales',
        lenseId: 1,
        attributes: [
            { isSelected: false, name: 'Sales Attribute1', attributeId: 1 },
            { isSelected: false, name: 'Sales Attribute2', attributeId: 1 },
            { isSelected: false, name: 'Sales Attribute3', attributeId: 1 },
            { isSelected: false, name: 'Sales Attribute4', attributeId: 1 },
            { isSelected: false, name: 'Sales Attribute5', attributeId: 1 },
            { isSelected: false, name: 'Sales Attribute41', attributeId: 1 },
            { isSelected: false, name: 'Sales Attribute52', attributeId: 1 },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Brand',
        lenseId: 1,
        attributes: [
            { isSelected: false, name: 'Brand Attribute1', attributeId: 1 },
            { isSelected: false, name: 'Brand Attribute2', attributeId: 1 },
            { isSelected: false, name: 'Brand Attribute3', attributeId: 1 },
            { isSelected: false, name: 'Brand Attribute4', attributeId: 1 },
            { isSelected: false, name: 'Brand Attribute5', attributeId: 1 },
            { isSelected: false, name: 'Brand Attribute41', attributeId: 1 },
            { isSelected: false, name: 'Brand Attribute52', attributeId: 1 },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Sub-brand',
        lenseId: 1,
        attributes: [
            { isSelected: false, name: 'Sub-brand Attribute1', attributeId: 1 },
            { isSelected: false, name: 'Sub-brand Attribute2', attributeId: 1 },
            { isSelected: false, name: 'Sub-brand Attribute3', attributeId: 1 },
            { isSelected: false, name: 'Sub-brand Attribute4', attributeId: 1 },
            { isSelected: false, name: 'Sub-brand Attribute5', attributeId: 1 },
            { isSelected: false, name: 'Sub-brand Attribute41', attributeId: 1 },
            { isSelected: false, name: 'Sub-brand Attribute52', attributeId: 1 },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Category',
        lenseId: 1,
        attributes: [
            { isSelected: false, name: 'Category Attribute1', attributeId: 1 },
            { isSelected: false, name: 'Category Attribute2', attributeId: 1 },
            { isSelected: false, name: 'Category Attribute3', attributeId: 1 },
            { isSelected: false, name: 'Category Attribute4', attributeId: 1 },
            { isSelected: false, name: 'Category Attribute5', attributeId: 1 },
            { isSelected: false, name: 'Category Attribute41', attributeId: 1 },
            { isSelected: false, name: 'Category Attribute52', attributeId: 1 },
        ],
    },
    {
        isAllSelected: false,
        lenseName: 'Manufacturer',
        lenseId: 1,
        attributes: [
            { isSelected: false, name: 'Manufacturer Attribute1', attributeId: 1 },
            { isSelected: false, name: 'Manufacturer Attribute2', attributeId: 1 },
            { isSelected: false, name: 'Manufacturer Attribute3', attributeId: 1 },
            { isSelected: false, name: 'Manufacturer Attribute4', attributeId: 1 },
            { isSelected: false, name: 'Manufacturer Attribute5', attributeId: 1 },
            { isSelected: false, name: 'Manufacturer Attribute41', attributeId: 1 },
            { isSelected: false, name: 'Manufacturer Attribute52', attributeId: 1 },
        ],
    },
];

// data fetching payload, getScenariosData()
const dataPayload = {
    kpis: [21, 23], // selected attributes
    searchKey: '',
    dim1: 'product',
    dim2: 'geography',
    filterConfig: {
        brand: ['b1', 'b2'], // include inclusion and exclu
        // packetSize:[],
        sub_brand: ['sb5'],
    },
    is_lowest: true,
    limit: 50,
    offset: 0,
};

// lowest level, if data is for lowest level we will have dim1 and dim2 info
const dataResponse = [
    {
        row_id: 1,
        dim1_name: 'kind core 6',
        dim2_name: 'publix',
        '21_input': 23,
        '21_actual': '23',
        '23_actual': '233',
        '23_output': '233',
    },
    {
        row_id: 2,
        dim1_name: 'kind core 12',
        dim2_name: 'publix',
        '21_input': 23,
        '21_actual': '23',
        '23_actual': '233',
        '23_output': '233',
    },
];

// pricing simulation payload / response - Fetch and Editing
// brand  level response, if data at higher level we dim1,2 will be null, as no editing is allowed
const dataResponseBrand = [
    {
        row_id: null,
        dim1_name: 'Kind core',
        dim2_name: 'publix',
        '21_input': null,
        '21_actual': '2323', // input columns wont make sense
        '23_actual': '233',
        '23_output': '233',
    },
    {
        row_id: null,
        dim1_name: 'kind core 12',
        dim2_name: 'publix',
        '21_input': 23,
        '21_actual': '23',
        '23_actual': '233',
        '23_output': '233',
    },
];

// Edidting - apply to column( all 2k records)
const dataPayloadColumn = {
    lenseId: 1,
    scenarioId: 12,
    kpiId: 21,
    searchKey: '',
    filterConfig: {
        brand: ['b1', 'b2'],
        sub_brand: ['sb5'],
    },
    type: 'incremental',
    value: 23,
};

// apply to  column( selected ), we will be sending rows as tuple
const dataPayloadSelected = {
    lenseId: 1,
    scenarioId: 12,
    kpis: 21,
    selected: [1, 2, 3], // row_ids
    type: 'incremental',
    value: 23,
};

// apply to  Cell, single cell update
const dataPayloadCell = {
    lenseId: 1,
    scenarioId: 12,
    kpiId: 21,
    selected: [12], // pk
    type: 'incremental',
    value: 23,
};
